import {
  cycleCountIdFormat,
  cycleCountLineIdFormat,
} from "@redotech/redo-ids-cockroach";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const removeCycleCountLines = unaryRpc({
  name: "removeCycleCountLines" as const,
  input: z.object({
    id: cycleCountIdFormat.schema,
    lineIds: z.array(cycleCountLineIdFormat.schema).min(1).max(500),
  }),
  output: z.object({ removedCount: z.int() }),
});
